import React from "react";
import styles from "./NoConvFound.module.css";
import images from "../../../utils/images";
const NoConvFound = () => {
  return (
    <div className={styles.NoCovFoundMain}>
      <div className={styles.NoCovFoundImage}>
        <img src={images.notConvFound} alt="img" />
      </div>
      <p className={styles.NoCovFoundTopic}>No conversation selected</p>
      <p className={styles.NoCovFoundParagraph}>
        Please select a conversation from the list to start chatting. Your
        messages will appear here once a chat is selected.
      </p>
    </div>
  );
};

export default NoConvFound;
